import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SwopsPage } from './swops.page';

const routes: Routes = [
  {
    path: '',
    component: SwopsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SwopsPageRoutingModule {}
